(() => {
  const setup = () => {
    const syncFocus = element => {
      element.querySelectorAll('.flickity-slider > .gitem').forEach(cell => {
        cell.inert = cell.getAttribute('aria-hidden') === 'true';
      });
    };
    const bind = element => {
      window.jQuery(element).on('select.flickity settle.flickity', () => syncFocus(element));
      new MutationObserver(() => syncFocus(element)).observe(element, {
        subtree: true,
        attributes: true,
        attributeFilter: ['aria-hidden']
      });
      syncFocus(element);
    };
    const initialize = element => {
      const options = element.getAttribute('data-deferred-flickity');
      if (!options) return;
      window.jQuery(element).flickity(JSON.parse(options));
      element.removeAttribute('data-deferred-flickity');
      bind(element);
    };
    if (!window.jQuery || !window.jQuery.fn.flickity) return;
    document.querySelectorAll('.carousel[data-flickity]').forEach(bind);
    const deferred = document.querySelectorAll('[data-deferred-flickity]');
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          initialize(entry.target);
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '500px 0px' });
      deferred.forEach(element => observer.observe(element));
    } else {
      deferred.forEach(initialize);
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, { once: true });
  else setup();
})();
